import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import materialService from "../../services/materialService";

export const fetchMaterials=createAsyncThunk(
    "materials/fetch",
    async()=>{

        return await materialService.getMaterials();

    }
);

export const removeMaterial=createAsyncThunk(
    "materials/delete",
    async(id)=>{

        await materialService.deleteMaterial(id);

        return id;

    }
);

export const addMaterial = createAsyncThunk(
    "materials/add",
    async (formData, thunkAPI) => {
        try {
            return await materialService.addMaterial(formData);
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message
            );
        }
    }
);

const materialSlice=createSlice({

    name:"materials",

    initialState:{
        materials:[],
        loading:false
    },

    reducers:{},

    extraReducers:(builder)=>{

        builder

.addCase(fetchMaterials.pending,(state)=>{
    state.loading=true;
})

.addCase(fetchMaterials.fulfilled,(state,action)=>{
    state.loading=false;
    state.materials=action.payload;
})

.addCase(fetchMaterials.rejected,(state)=>{
    state.loading=false;
})

.addCase(addMaterial.fulfilled,(state,action)=>{

    state.materials.unshift(action.payload);

})

.addCase(removeMaterial.fulfilled,(state,action)=>{

    state.materials=
    state.materials.filter(
        x=>x._id!==action.payload
    );

});

    }

});

export default materialSlice.reducer;